import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseHttpService } from './base.http.service';
import { ITransactionTypeParam, ITransactionSearchParam } from 'src/app/models/transactions';
import { IPagingInfo } from 'src/app/models/pagingInfo';
import { GeneralSelectionFacade } from 'src/app/store/general-selection/facade/general-selection.facade';
import { AppConfig } from 'src/app/app.config';
import { IEnvironmentConfig } from 'src/app/models/environmentConfig';

@Injectable()
export class TransactionsService extends BaseHttpService {

    public GeneralSelectionFacade: GeneralSelectionFacade;
    constructor(private http: HttpClient, generalSelectionFacade: GeneralSelectionFacade, private appConfig: AppConfig) {
        super();
    }

    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }

    public getPaginatedTransactions(payload: ITransactionSearchParam): Observable<any> {
        let queryString = '?endDate=' + this.parseDate(payload.toDate);
        if (payload.fromDate !== undefined && payload.fromDate !== null) {
            queryString = queryString + '&startDate=' + this.parseDate(payload.fromDate);
        }
        payload.entities.forEach((entity) => {
            queryString = queryString + '&entities=' + entity.EntityId;
        });

        payload.portfolios.forEach((portfolio) => {
            queryString = queryString + '&portfolios=' + portfolio.id;
        });

        if (payload.pagingInfo) {
            queryString = queryString + this.buildPagingInfoQueryString(payload.pagingInfo);
        }

        if (payload.transactionActionType !== undefined && payload.transactionActionType !== null && payload.transactionActionType.value != 0) {
            queryString = queryString + '&transactionActionType=' + payload.transactionActionType.value;
        }

        if(payload.accountType !== undefined && payload.accountType !== null){
            queryString = queryString + '&accountType=' + payload.accountType
        }

        const url = `${this.envSettings.webApiUrl}portfolio/transactions/paging/${queryString}`;

        return this.http.get(url, {
            observe: "body",
            responseType: "json",
            headers: this.getHttpHeaders()
        });
    }

    public getTransactionTypes(payload: ITransactionTypeParam): Observable<any> {

        let queryString = '?endDate=' + this.parseDate(payload.toDate);

        payload.entities.forEach((item) => {
            queryString = queryString + '&entities=' + item.EntityId;
        });

        payload.portfolios.forEach((item) => {
            queryString = queryString + '&portfolios=' + item.id;
        });

        if (payload.accountType !== undefined && payload.accountType !== null) {
            queryString = queryString + '&accountType=' + payload.accountType
        }

        const url = `${this.envSettings.webApiUrl}portfolio/transactions/relevanttypes/${queryString}`;
        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    private buildPagingInfoQueryString(pagingInfo: IPagingInfo): string {
        let queryString = '&pageSize=' + pagingInfo.pageSize + '&pageNumber=' + pagingInfo.pageNumber
        return queryString;
    }
}

